import React, { useEffect, useState } from "react";
import { Modal, View, Text, ScrollView } from "react-native-web";
import { Grid} from "@mui/material";
//components
import CloseButton from "../../../components/button/CloseButton";
import Button from "../../../components/button/Button";
import TextField from "../../../components/textField/TextField";
import Dropdown from "../../../components/dropdown/Dropdown";
import { useDialog } from "../../../components/modal/Popup";
//functions
import { calculatorFontSize } from "../../../functions/screen/screenFunction";
import {
  validatePhone,
} from "../../../functions/validate/validate";
import {
  downloadAllCountry,
  downloadAllProvince,
  downloadAllDistrict,
  downloadAllSubDistrict,
  downloadAllZipcode,
} from "../../../services/api/masterdata/address";
import apiPath from "../../../services/configs/apiPath";
import { validateEmail } from "../../../functions/validate/validate";
import { post } from "../../../functions/fetch/fetch";
//images
import { CorrectCircleIcon } from "../../../asset/images/icons/iconsLib";
import {
  formatNumber,
  formatNumberString,
} from "../../../functions/format/numberFormat";


const PopupAddCustomer = (props) => {
  const { visible, data, saleCode, editData} = props;
  const { title, subTitle } = props;
  const { onEnter, onClose } = props;
  const dialog = useDialog();
  //state
  const [countryList, setCountryList] = useState([]);
  const [provinceList, setProvinceList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [subDistrictList, setSubDistrictList] = useState([]);
  const [zipcodeList, setZipcodeList] = useState([]);
  const [customerData, setCustomerData] = useState({
    name: null,
    email: null,
    countryCode: "THA",
    phoneNumber: null,
    address: null,
    provinceCode: null,
    province: null,
    districtCode: null,
    district: null,
    subDistrictCode: null,
    subDistrict: null,
    zipcode: null,
    facebook: null,
    instragram: null,
    initEditComplete:false,
  });

  useEffect(() => {
    const downloadAllData = async () => {
      dialog.loading();
      let countrys = await downloadAllCountry();
      let initCountrys = [];
      countrys.forEach((item) => {
        initCountrys.push({
          value: item.countryCode,
          label: item.countryNameTh,
        });
      });
      setCountryList(initCountrys);

      let provinces = await downloadAllProvince();
      let initProvinces = [];
      provinces.forEach((item) => {
        initProvinces.push({ value: item.provinceCode, label: item.province });
      });
      setProvinceList(initProvinces);
      dialog.cancle();
    };
    downloadAllData();
  }, []);

  useEffect(() => {
    if(editData && provinceList.length > 0 &&  !customerData.initEditComplete){
      console.log("เปิดกำลัง set",editData)
      dialog.loading();
      setCustomerData({
        ...customerData,
        ...editData,
        district:null,
        districtCode:null,
        subDistrict:null,
        subDistrictCode:null,
        zipcode:null,
      })
    }
    if(!visible){
      setCustomerData({
        name: null,
        email: null,
        countryCode: "THA",
        phoneNumber: null,
        address: null,
        provinceCode: null,
        province: null,
        districtCode: null,
        district: null,
        subDistrictCode: null,
        subDistrict: null,
        zipcode: null,
        facebook: null,
        instragram: null,
        initEditComplete:false,
      });
    }

  }, [visible,provinceList]);

  useEffect(() => {
    if (customerData.provinceCode) {
      initDistrictList();
      setCustomerData({
        ...customerData,
        districtCode:(editData && !customerData.initEditComplete) ? editData.districtCode : null,
        district: null,
        subDistrictCode: null,
        subDistrict: null,
        zipcode: null,
      });
        setSubDistrictList([]);
        setZipcodeList([]);
      
    }
  }, [customerData?.provinceCode]);



  useEffect(() => {
    if (customerData.provinceCode && customerData.districtCode) {
      initSubDistrictList();
      setCustomerData({
        ...customerData,
        subDistrictCode: (editData && !customerData.initEditComplete) ? editData.subDistrictCode : null,
        subDistrict: null,
        zipcode: null,
      });
        setZipcodeList([]);
    }
  }, [customerData?.districtCode]);

  useEffect(() => {
    getZipcodeList();
  }, [customerData?.subDistrictCode,subDistrictList]);

  const initDistrictList = async () => {
    let districtList = await getDistrictList();
    setDistrictList(districtList);
  }

  const getDistrictList = async (_provinceCode) => {
    let districtList = await downloadAllDistrict(_provinceCode ? _provinceCode : customerData.provinceCode);
    let initDistrictList = [];
    districtList.forEach((item) => {
      initDistrictList.push({
        value: item.districtCode,
        label: item.district,
      });
    });
    return initDistrictList;
  };

  const initSubDistrictList = async () => {
    let subDistrictList = await getSubDistrictList();
    setSubDistrictList(subDistrictList);
  }

  const getSubDistrictList = async (_provinceCode,_districtCode) => {
    let subDistrictList = await downloadAllSubDistrict(
      _provinceCode ? _provinceCode : customerData.provinceCode,
      _districtCode ? _districtCode : customerData.districtCode
    );
    let initSubDistrictList = [];
    subDistrictList.forEach((item) => {
      initSubDistrictList.push({
        value: item.subDistrictCode,
        label: item.subDistrict,
      });
    });
    return initSubDistrictList;
  };

  const getZipcodeList = async () => {
    if(provinceList.length === 0){
      return;
    }
    const findWithProvince = (editData && !customerData.initEditComplete) ? Number(editData.provinceCode) : Number(customerData.provinceCode);
    const findWithDistrict = (editData && !customerData.initEditComplete) ? Number(editData.districtCode) : Number(customerData.districtCode);
    const findWithSubDistrict = (editData && !customerData.initEditComplete) ? Number(editData.subDistrictCode) : Number(customerData.subDistrictCode);
    
    if(!findWithProvince || !findWithDistrict || !findWithSubDistrict){
      return;
    }

    const _districtList = await getDistrictList(findWithProvince);
    const _subDistrictList = await getSubDistrictList(findWithProvince,findWithDistrict);
    console.log("findWithProvince",findWithProvince,"findWithDistrict",findWithDistrict,"findWithSubDistrict",findWithSubDistrict)
    let province = provinceList.find((item) => {return Number(item.value) === findWithProvince});
    let district = _districtList.find((item) => Number(item.value) === findWithDistrict);
    let subDistrict = _subDistrictList.find((item) => Number(item.value) === findWithSubDistrict);
    if(!province || !district || !subDistrict){
      return;
    }
    console.log("province",province,"district",district,"subDistrict",subDistrict)
    let zipcodeList = await downloadAllZipcode(
      province.label,
      district.label,
      subDistrict.label
    );
    let initZipcodeList = [];
    zipcodeList.forEach((item) => {
      initZipcodeList.push({
        value: item.zipcode,
        label: item.zipcode,
      });
    });
    console.log("zipcodeList",initZipcodeList)
    setZipcodeList(initZipcodeList);

    if(editData && !customerData.initEditComplete){
      setCustomerData({
        ...customerData,
        zipcode: editData.zipcode,
        initEditComplete: true
      });
    }
    dialog.cancle();
  };

  const submit = async () => {
    let valid = true;
    const {
      name,
      email,
      countryCode,
      phoneNumber,
      address,
      provinceCode,
      districtCode,
      subDistrictCode,
      zipcode,
    } = customerData;

    // if (!email) {
    //   await dialog.alert({
    //     title: "แจ้งเตือน",
    //     message: "กรุณาระบุอีเมล",
    //   });
    //   return;
    // }
    // if (email && !validateEmail(email)) {
    //   await dialog.alert({
    //     title: "แจ้งเตือน",
    //     message: "รูปแบบของอีเมล์ไม่ถูกต้อง",
    //   });
    //   return;
    // }

    if (!name || !address || !phoneNumber) {
      valid = false;
    }

    let matchCountryCode = countryList.find((item) => item.value === countryCode);
    if (!matchCountryCode) {
      valid = false;
      await dialog.alert({
        title: "แจ้งเตือน",
        message: "เกิดข้อผิดพลาด ประเทศไม่ถูกต้อง กรุณาเลือกใหม่อีกครั้ง โดยการสลับเป็นประเทศอื่นก่อน และเลือกประเทศที่ต้องการอีกครั้ง",
      });
      return;
    }

    if (countryCode === "THA") {
      if (!provinceCode || !districtCode || !subDistrictCode || !zipcode) {
        valid = false;
      }
      if (!validatePhone(phoneNumber)) {
        await dialog.alert({
          title: "แจ้งเตือน",
          message: "เบอร์โทรศัพท์ไม่ถูกต้อง",
        });
        return;
      }
    }

    if (!valid) {
      await dialog.alert({
        title: "แจ้งเตือน",
        message: "กรุณากรอกข้อมูลให้ครบถ้วน",
      });
      return;
    }
    if(editData){
      dialog.loading();
      let url = apiPath.sales.updateCustomerSales;
      let { status, response } = await post(
        url,
        {
          ...customerData,
          saleCode: saleCode,
          appName:"onelife",
        },
        true
      );
      if (!status) {
        await dialog.alert({ title: "แจ้งเตือน", message: response.data.error });
        dialog.cancle();
        return;
      }
  
      await dialog.alert({ title: "แจ้งเตือน", message: "บันทึกเรียบร้อย" });
      dialog.cancle();
    }else{
      dialog.loading();
      let url = apiPath.sales.addCustomerSales;
      let { status, response } = await post(
        url,
        {
          ...customerData,
          saleCode: saleCode,
          appName:"onelife"
        },
        true
      );
      if (!status) {
        await dialog.alert({ title: "แจ้งเตือน", message: response.data.error });
        dialog.cancle();
        return;
      }

      await dialog.alert({ title: "แจ้งเตือน", message: "เพิ่มลูกค้าเรียบร้อย" });
      dialog.cancle();
    }
    onClose && onClose();
  };

  return (
    <Modal transparent={true} visible={visible ? visible : false}>
      <View style={Styles.modalContainer}>
        <View style={Styles.box}>
          <View style={Styles.headerBox}>
            <View style={{ flex: 1 }}>
              <Text style={Styles.headerTitle}>{editData ? "แก้ไขลูกค้า" : "เพิ่มลูกค้า"}</Text>
            </View>
            <CloseButton
              onPress={() => {
                onClose && onClose();
              }}
            />
          </View>
          <View style={{ height: 20 }} />
          <ScrollView
            style={{ width: "100%", padding: 5 }}
            showsVerticalScrollIndicator={false}
          >
            <Grid container spacing={4} style={{}}>
              <Grid item xs={12}>
                <View
                  style={{
                    width: "100%",
                    height: 1,
                    backgroundColor: "rgba(242, 242, 242, 1)",
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Text style={Styles.titleTextField}>
                  ชื่อ - นามสกุล{" "}
                  <Text style={{ color: "rgba(204, 0, 0, 1)" }}> *</Text>
                </Text>
                <View style={{ height: 8 }} />
                <TextField
                  value={customerData.name ? customerData.name : null}
                  iconName={""}
                  isInvalid={false}
                  placeholder={"ระบุชื่อ - นามสกุล"}
                  errorMessage={""}
                  onChangeText={(value) => {
                    setCustomerData({
                      ...customerData,
                      name: value,
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Text style={Styles.titleTextField}>
                  อีเมล
                  {/* อีเมล <Text style={{ color: "rgba(204, 0, 0, 1)" }}> *</Text> */}
                </Text>
                <View style={{ height: 8 }} />
                <TextField
                  value={customerData.email ? customerData.email : null}
                  iconName={""}
                  isInvalid={false}
                  placeholder={"ระบุอีเมล"}
                  errorMessage={""}
                  onChangeText={(value) => {
                    setCustomerData({
                      ...customerData,
                      email: value,
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Text style={Styles.titleTextField}>
                  เบอร์โทรศัพท์
                  <Text style={{ color: "rgba(204, 0, 0, 1)" }}> *</Text>
                </Text>

                <View style={{ height: 8 }} />
                <TextField
                  value={customerData.phoneNumber ? customerData.phoneNumber : null}
                  iconName={""}
                  isInvalid={false}
                  placeholder={"ระบุเบอร์โทรศัพท์"}
                  errorMessage={""}
                  onChangeText={(value) => {
                    let num = formatNumberString(value);
                    if (num.length <= 10) {
                      setCustomerData({
                        ...customerData,
                        phoneNumber: num,
                      });
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Text style={Styles.titleTextField}>
                  ประเทศ
                  <Text style={{ color: "rgba(204, 0, 0, 1)" }}> *</Text>
                </Text>
                <View style={{ height: 8 }} />
                <Dropdown
                  value={customerData.countryCode}
                  valueType={"string"}
                  placeholder={"เลือกประเทศ"}
                  list={countryList}
                  style={{ zIndex: 100010 }}
                  onChange={(values) => {
                    const { value, label } = values;
                    setCustomerData({
                      ...customerData,
                      countryCode: value,
                    });
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <Text style={Styles.titleTextField}>
                  ที่อยู่
                  <Text style={{ color: "rgba(204, 0, 0, 1)" }}> *</Text>
                </Text>

                <View style={{ height: 8 }} />
                <TextField
                  value={customerData.address ? customerData.address : null}
                  iconName={""}
                  isInvalid={false}
                  placeholder={"ระบุที่อยู่"}
                  errorMessage={""}
                  onChangeText={(value) => {
                    setCustomerData({
                      ...customerData,
                      address: value,
                    });
                  }}
                />
              </Grid>

              {customerData && customerData.countryCode === "THA" ? (
                <Grid item xs={12} md={6}>
                  <Text style={Styles.titleTextField}>
                    จังหวัด
                    <Text style={{ color: "rgba(204, 0, 0, 1)" }}> *</Text>
                  </Text>
                  <View style={{ height: 8 }} />
                  <Dropdown
                    value={customerData.provinceCode}
                    valueType={"number"}
                    placeholder={"เลือกจังหวัด"}
                    list={provinceList}
                    style={{ zIndex: 100009 }}
                    onChange={(values) => {
                      const { value, label } = values;
                      setCustomerData({
                        ...customerData,
                        provinceCode: String(value),
                        province: label,
                      });
                    }}
                  />
                </Grid>
              ) : null}

              {customerData && customerData.countryCode === "THA" ? (
                <Grid item xs={12} md={6}>
                  <Text style={Styles.titleTextField}>
                    เขต/อำเภอ
                    <Text style={{ color: "rgba(204, 0, 0, 1)" }}> *</Text>
                  </Text>
                  <View style={{ height: 8 }} />
                  <Dropdown
                    value={customerData.districtCode}
                    valueType={"number"}
                    disable={districtList.length === 0}
                    placeholder={"เลือกเขต/อำเภอ"}
                    list={districtList}
                    style={{ zIndex: 100008 }}
                    onChange={(values) => {
                      const { value, label } = values;
                      setCustomerData({
                        ...customerData,
                        districtCode: String(value),
                        district: label,
                      });
                    }}
                  />
                </Grid>
              ) : null}

              {customerData && customerData.countryCode === "THA" ? (
                <Grid item xs={12} md={6}>
                  <Text style={Styles.titleTextField}>
                    แขวง/ตำบล
                    <Text style={{ color: "rgba(204, 0, 0, 1)" }}> *</Text>
                  </Text>
                  <View style={{ height: 8 }} />
                  <Dropdown
                    value={customerData.subDistrictCode}
                    valueType={"number"}
                    disable={subDistrictList.length === 0}
                    placeholder={"เลือกแขวง/ตำบล"}
                    list={subDistrictList}
                    style={{ zIndex: 100007 }}
                    onChange={(values) => {
                      const { value, label } = values;
                      setCustomerData({
                        ...customerData,
                        subDistrictCode: String(value),
                        subDistrict: label,
                      });
                    }}
                  />
                </Grid>
              ) : null}

              {customerData && customerData.countryCode === "THA" ? (
                <Grid item xs={12} md={6}>
                  <Text style={Styles.titleTextField}>
                    รหัสไปรษณีย์
                    <Text style={{ color: "rgba(204, 0, 0, 1)" }}> *</Text>
                  </Text>
                  <View style={{ height: 8 }} />
                  <Dropdown
                    value={customerData.zipcode}
                    valueType={"string"}
                    disable={subDistrictList.length === 0 || !customerData.subDistrictCode}
                    placeholder={"เลือกรหัสไปรษณีย์"}
                    list={zipcodeList}
                    style={{ zIndex: 100006 }}
                    onChange={(values) => {
                      const { value, label } = values;
                      setCustomerData({
                        ...customerData,
                        zipcode: String(value),
                      });
                    }}
                  />
                </Grid>
              ) : null}

              <Grid item xs={12} md={6}>
                <Text style={Styles.titleTextField}>Facebook</Text>
                <View style={{ height: 8 }} />
                <TextField
                  value={customerData.facebook ? customerData.facebook : null}
                  iconName={""}
                  isInvalid={false}
                  placeholder={"ระบุชื่อ Facebook"}
                  errorMessage={""}
                  onChangeText={(value) => {
                    setCustomerData({
                      ...customerData,
                      facebook: value,
                    });
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Text style={Styles.titleTextField}>Instragram</Text>
                <View style={{ height: 8 }} />
                <TextField
                  value={customerData.instragram ? customerData.instragram : null}
                  iconName={""}
                  isInvalid={false}
                  placeholder={"ระบุชื่อ Instragram"}
                  errorMessage={""}
                  onChangeText={(value) => {
                    setCustomerData({
                      ...customerData,
                      instragram: value,
                    });
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <View
                  style={{
                    width: "100%",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Button
                    buttonText={"ยกเลิก"}
                    color={"primary"}
                    isBorder={true}
                    style={{ width: "100%", maxWidth: 400 }}
                    onClick={() => {
                      onClose && onClose();
                    }}
                  />
                  <View style={{ width: 20 }} />
                  <Button
                    buttonText={editData ? "บันทึกข้อมูล" : "เพิ่มลูกค้า"}
                    color={"primary"}
                    style={{ width: "100%", maxWidth: 400 }}
                    onClick={() => {
                      submit();
                    }}
                  />
                </View>
              </Grid>
            </Grid>
          </ScrollView>
        </View>
      </View>
    </Modal>
  );
};

const Styles = {
  modalContainer: {
    position: "fixed",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 9999,
    alignItems: "center",
    justifyContent: "center",
  },
  box: {
    width: "90%",
    maxHeight: "90%",
    maxWidth: 1280,
    padding: 20,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#FFF",
    borderRadius: 16,
    shadowColor: "#000000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 16,
  },
  headerBox: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  headerTitle: {
    fontSize: calculatorFontSize(16, 20),
    color: "rgba(15, 16, 17, 1)",
    flex: 1,
  },
  titleTextField: {},
  dropdownContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
};

export default PopupAddCustomer;
